/**
 * Card Buy Box v15 - navigation cards (2026-07).
 * The site-wide product card is now a PURE NAVIGATION card (owner decision
 * "option A"): the whole card links to the product page. All of the old card
 * commerce logic (card-add-to-cart element, variant pills, one-time purchase
 * links, tooltip handling, qty/cadence state, data-ladder parsing) has been
 * removed with the markup that used it.
 *
 * What remains is the Lipscore support the card grids still rely on:
 *  - extract the numeric score from the Lipscore small-rating widget and
 *    render it next to the stars;
 *  - re-init Lipscore widgets (and re-extract scores) when the collection
 *    grid changes (infinite scroll, facet filtering).
 * This file is loaded globally from layout/theme.liquid, so everything here
 * must no-op safely on pages without product grids.
 */

/**
 * Extract Lipscore rating score from visually-hidden text and display it.
 * Lipscore renders "X.X out of 5 stars" in a hidden span. We read the score
 * out and append a visible element after the stars.
 */
function showLipscoreScores() {
  document.querySelectorAll('.lipscore-rating-small').forEach(function(widget) {
    if (widget.dataset.scoreAdded === 'true') return;
    // Check if Lipscore has rendered content
    if (widget.children.length === 0) return;

    var hiddenSpans = widget.querySelectorAll('.lipscore-visually-hidden');
    var scoreText = '';
    hiddenSpans.forEach(function(span) {
      var match = span.textContent.match(/(\d+\.?\d*)\s+out of\s+5/);
      if (match) scoreText = match[1];
    });

    if (scoreText) {
      var scoreEl = document.createElement('span');
      scoreEl.className = 'lipscore-score-text';
      scoreEl.textContent = scoreText;
      widget.appendChild(scoreEl);
      widget.dataset.scoreAdded = 'true';
    }
  });
}

/* Run score extraction after Lipscore initializes */
document.addEventListener('DOMContentLoaded', function() {
  // Lipscore loads async, so poll until widgets are populated
  var scoreInterval = setInterval(function() {
    var populated = document.querySelector('.lipscore-rating-small .lipscore-visually-hidden');
    if (populated) {
      clearInterval(scoreInterval);
      showLipscoreScores();
    }
  }, 500);
  // Stop polling after 10 seconds
  setTimeout(function() { clearInterval(scoreInterval); }, 10000);
});

/* MutationObserver: re-init Lipscore widgets when new cards are added
   to the collection grid (e.g. infinite scroll, facet filtering) */
(function() {
  var observerTimeout;
  var productGrid = document.querySelector('.product-grid.flex-grid');
  if (!productGrid) return;

  var observer = new MutationObserver(function() {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(function() {
      if (typeof lipscore !== 'undefined' && typeof lipscore.initWidgets === 'function') {
        try { lipscore.initWidgets(); } catch(e) {}
      }
    }, 300);
  });

  observer.observe(productGrid, { childList: true, subtree: false });
})();

/* Also re-extract numeric scores after infinite scroll loads new products */
var _lipscoreScoreObserver = new MutationObserver(function() {
  setTimeout(showLipscoreScores, 1000);
});
var _lipscoreGrid = document.querySelector('.product-grid.flex-grid');
if (_lipscoreGrid) {
  _lipscoreScoreObserver.observe(_lipscoreGrid, { childList: true, subtree: true });
}
